module.exports = ".sticky {\n  position: sticky;\n  top: 0;\n}\n"